import React from 'react';
import BottomSheet from '@/app/components/bottom_sheet/widget';
import { ThirtyText, TextBold16 } from '@/app/components/texts';
import Button from '@/app/components/button/widget';
import { t } from 'i18next';
import { s } from '@/app/utils/s';
import styles from '../styles.module.scss';

interface MatchConflictDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Dialog for showing match conflict warning when user already has a match at the same time
 */
const MatchConflictDialog: React.FC<MatchConflictDialogProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <BottomSheet open={isOpen} onClose={onClose}>
      <div className={styles.matchConflictDialog}>
        <ThirtyText text={t(s.matchConflictTitle)} />
        <TextBold16 text={t(s.matchConflictMessage)} />
        <div className={styles.buttons}>
          <Button text={t(s.confirm)} onClick={onClose} isGreen />
        </div>
      </div>
    </BottomSheet>
  );
};

export default MatchConflictDialog;